import { useUserInfo, useIsUserInRole, selectedDatabaseIdState } from '@transport-insights/uikit';
import { useRecoilValue } from 'recoil';

function RoleGuard({ allowedRoles = [], children, fallback = null }) {
  const hasDeveloperRole = useIsUserInRole('Developer');
  const { roles } = useUserInfo();
  const rcaId = useRecoilValue(selectedDatabaseIdState);

  // No restriction → always show
  if (!allowedRoles.length) return children;

  // Still loading roles
  if (!roles) return null;

  const isAllowed = hasDeveloperRole || roles.some((role) => {
    // Global role match
    if (allowedRoles.includes(role)) return true;

    // DB scoped role match (only if rcaId exists)
    if (rcaId) {
      return allowedRoles.some(
        (allowedRole) => role === `db:${rcaId}:${allowedRole}`,
      );
    }

    return false;
  });

  return isAllowed ? children : fallback;
}

export default RoleGuard;
